import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  actions: {
    '& > .MuiButton-root': {
      width: theme.spacing(8),
    },
  },
}));
